import React from 'react';
import type { ProductStatus } from '../data/site';
type StatusTagProps = {
  status: ProductStatus;
  timing?: string;
  tone?: 'light' | 'dark';
};
export function StatusTag({
  status,
  timing,
  tone = 'light'
}: StatusTagProps) {
  const live = status === 'Live';
  const dotClass = live ? 'bg-bronze-500' : tone === 'dark' ? 'bg-ink-500' : 'bg-ink-300';
  return <span className="inline-flex items-center gap-2.5 text-xs font-medium uppercase tracking-[0.14em]" data-id="element-191" data-mp="2hktrk6edl9zp">
      <span className={`block h-1.5 w-1.5 rounded-full ${dotClass}`} aria-hidden="true" data-id="element-192" data-mp="2djrpziwzkluk" />
      <span className={tone === 'dark' ? 'text-white' : 'text-ink-900'} data-id="element-193" data-mp="2rj9gc2pxk761">{status}</span>
      {timing && <span className={tone === 'dark' ? 'text-ink-500' : 'text-ink-400'} data-id="element-194" data-mp="2mkg38bek2i6e">
          · {timing}
        </span>}
    </span>;
}